import { pathJoin } from 'src/reducers/routing/utils'

export const createProductManagementRoutesMap = (prefix: string) => ({
  'waste-fractions': pathJoin(prefix)('waste-fractions').chain,
  categories: pathJoin(prefix)('categories').chain,
  'categories/:id': (id = ':id') => pathJoin(prefix)('categories')(id).chain,
  'pricing-units': pathJoin(prefix)('pricing-units').chain,
  zones: pathJoin(prefix)('zones').chain,
  'price-lists': pathJoin(prefix)('price-lists').chain,
  products: pathJoin(prefix)('products').chain,
  'products/:id': (id = ':id') => pathJoin(prefix)('products')(id).chain,
  'service-levels': pathJoin(prefix)('service-levels').chain,
  'bill-of-materials': pathJoin(prefix)('bill-of-materials').chain,
  'audit-logs': pathJoin(prefix)('audit-logs').chain,
  'price-lists/:id': (id = ':id') => pathJoin(prefix)('price-lists')(id).chain,
  'products/new': pathJoin(prefix)('products')('new').chain,
  'price-determination-playground': pathJoin(prefix)(
    'price-determination-playground'
  ).chain,
  'timing-pricing': pathJoin(prefix)('timing-pricing').chain,
})
